import React, {useState} from 'react';
import {bool, object, func} from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import * as ArchitectActions from '../../actions/architectActions';

import classes from './TableRowMenu.module.css';

const LinksTableRowMenu = ({
    link,
    companyInfo,
    hidden,
    onToggleDeleteLinkModal,
    setLink
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    if (hidden) {
        return null;
    }

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
        setLink(link);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleDeleteLink() {
        onToggleDeleteLinkModal(true);

        handleClose();
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                <MenuItem
                    onClick={handleDeleteLink}
                    classes={{
                        root: link.agentConfigurationId ? '' : classes.disabled
                    }}
                >
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/deleteIconColor.svg"
                    />
                    Delete Link
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

LinksTableRowMenu.defaultProps = {
    hidden:                  false,
    onToggleDeleteLinkModal: () => {},
    onToggleEditLinkModal:   () => {},
    setLink:                 () => {}
};

LinksTableRowMenu.propTypes = {
    link:                    object,
    companyInfo:             object,
    hidden:                  bool,
    onToggleDeleteLinkModal: func,
    setLink:                 func
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default withRouter(
    connect(null, mapDispatchToProps)(LinksTableRowMenu)
);
